// extracted by mini-css-extract-plugin
module.exports = {"icon":"UserIcon_icon__3AHhl"};